module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av689-0d1203719c4f56e49a563fcd1f59c642.jpg";